
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as maphgk5oYpnbnbzLWRqLhLhXBQKmQXG_hfnFONSxGMbueQMeta } from "/opt/buildhome/repo/app/pages/map.vue?macro=true";
import { default as indexBUquJ6FW9selPoMmXmiQ06xberjjtjDDexnQK6NGwH0Meta } from "/opt/buildhome/repo/app/pages/index.vue?macro=true";
import { default as peaksdu_rFFLS459L_45z49VWRjL7RgfuTTNgpxfrj4JhoiC8YMeta } from "/opt/buildhome/repo/app/pages/peaks.vue?macro=true";
import { default as zoneAxuWrBnnHKH_n7wzsnNbYkXKlXMT_acfEeaDn2m3HuIMeta } from "/opt/buildhome/repo/app/pages/atlas/zone.vue?macro=true";
import { default as peaks79ihe5I1JH8zkQKSq02U4baIJJ_dLhwj0QVTpVDAH6QMeta } from "/opt/buildhome/repo/app/pages/atlas/peaks.vue?macro=true";
import { default as rain_45totalsi4hk262s_yRckSPtQ2nClKMnqQEHAfhGAzbiidk4_AQMeta } from "/opt/buildhome/repo/app/pages/rain-totals.vue?macro=true";
import { default as snow_45totalsmZP7z8B0o4sZ6VWwRncQ_45ZfayW6s8hfVQsTnnJQJjBQMeta } from "/opt/buildhome/repo/app/pages/snow-totals.vue?macro=true";
import { default as countyN54aYX9dBmrWPfBBFTBPfBSSoeBALWLWyv5KdjGQ0DQMeta } from "/opt/buildhome/repo/app/pages/atlas/county.vue?macro=true";
import { default as address6VIIlRM2RMItOx3euHNCE6fnDzFGruUyzeYWfrzbYgUMeta } from "/opt/buildhome/repo/app/pages/atlas/address.vue?macro=true";
import { default as cicadas1TnVICtaCAEqDPecOsJL2RMkLh3IKGnO55bl7MQIzpUMeta } from "/opt/buildhome/repo/app/pages/atlas/cicadas.vue?macro=true";
import { default as zipcodejpbHUGgayQeLjhyOZ4Q0sYq_RxMj258YNtypDaVGMmMMeta } from "/opt/buildhome/repo/app/pages/atlas/zipcode.vue?macro=true";
import { default as _91_91slug_93_93lN9MZ_jSMtxBcFzhpf4fV1h17HOe4jVTrU2dy8r6rCYMeta } from "/opt/buildhome/repo/app/pages/about/[[slug]].vue?macro=true";
import { default as townshipBKXgrBam8ogiGnk55XXrxgGZj44oka7aa4Mvp8cVAXQMeta } from "/opt/buildhome/repo/app/pages/atlas/township.vue?macro=true";
import { default as cicadas_45near_45me4TvBmdv83heuX4HfUOXcOqTikmhtMRRXbRgH6biAN1UMeta } from "/opt/buildhome/repo/app/pages/cicadas-near-me.vue?macro=true";
import { default as what_45is_45my_45cityg2RZnUlyhh52dKqr6Sb4Ly_O__45s9EnT_cZRgen45G_45MMeta } from "/opt/buildhome/repo/app/pages/what-is-my-city.vue?macro=true";
import { default as indexQPhx4Am1lJC7IKzUePT0LfjkaRNcT9I_86gjc9BmQewMeta } from "/opt/buildhome/repo/app/pages/county-map/index.vue?macro=true";
import { default as what_45is_45my_45statexevo4E3tWSvBZmqCaSsQMO9zw25NNzNX6iOAhbATC7YMeta } from "/opt/buildhome/repo/app/pages/what-is-my-state.vue?macro=true";
import { default as rain_45totalsZVWuuizfWvh1NrtqinbdaLDmUaafEzqr5T2vb2I_Q28Meta } from "/opt/buildhome/repo/app/pages/atlas/rain-totals.vue?macro=true";
import { default as snow_45totalsRcYE_45YIr7GPRk4__45xt1AIi9sBkcfaqnzlaUN03Z_452UQMeta } from "/opt/buildhome/repo/app/pages/atlas/snow-totals.vue?macro=true";
import { default as what_45is_45my_45parishdlLC9xVExw0Gvvd4ueKhH5Y3ALMOq4cDO6fGST_45eK0gMeta } from "/opt/buildhome/repo/app/pages/what-is-my-parish.vue?macro=true";
import { default as what_45town_45am_45i_45inFBt3oBlPdKySFOSYbhcUCEht0WFlaobM21cC9zUuY_wMeta } from "/opt/buildhome/repo/app/pages/what-town-am-i-in.vue?macro=true";
import { default as what_45zone_45am_45i_45in8NBW4sKv04ldUYlLQT_LXqpkq946wkuwZ95CSuB5EOsMeta } from "/opt/buildhome/repo/app/pages/what-zone-am-i-in.vue?macro=true";
import { default as index_46server5_mjJGMoimgQFjaPWwt9sv9vEwwH2hLieYw_45sSGetycMeta } from "/opt/buildhome/repo/app/pages/atlas/index.server.vue?macro=true";

let _createIslandPage
async function createIslandPage (name) {
  _createIslandPage ||= await import("/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.17.2_typescript@5.8.3_vite@6.3.5/node_modules/nuxt/dist/components/runtime/server-component.js").then(r => r.createIslandPage)
  return _createIslandPage(name)
};
import { default as neighborhoodwnhyC_45QMt7m0daH9RffakVVYInht413YdxFu_kxoz1MMeta } from "/opt/buildhome/repo/app/pages/atlas/neighborhood.vue?macro=true";
import { default as what_45is_45my_45addressQRPobI4hMLuBcOG_JW9dSLyAIBE9OwetfitPVHODpE4Meta } from "/opt/buildhome/repo/app/pages/what-is-my-address.vue?macro=true";
import { default as what_45is_45my_45countryZJEihM4HdQOH0KKhbTqdXFNCOvSiuo2pvKldLJwpNwMMeta } from "/opt/buildhome/repo/app/pages/what-is-my-country.vue?macro=true";
import { default as what_45is_45my_45zipcodeKvVhAINGGO8iy0b6HoSS7anDCuDw7dOaVyyj8KmY2LwMeta } from "/opt/buildhome/repo/app/pages/what-is-my-zipcode.vue?macro=true";
import { default as yesterdays_45weatherCkMyhEfKtwi9ATL_458jNT3BoTT_OyF0mRFwqldQwVYBoMeta } from "/opt/buildhome/repo/app/pages/yesterdays-weather.vue?macro=true";
import { default as how_45fast_45am_45i_45goingB1DJwgFbMkZ8g3VTx7FV3kIaNsksYCTXpXhXp6yBceoMeta } from "/opt/buildhome/repo/app/pages/how-fast-am-i-going.vue?macro=true";
import { default as what_45barrio_45am_45i_45inaPkjVAV_HhSpUKxx4TTplIATNIGhqGHmznAxHA6C_45koMeta } from "/opt/buildhome/repo/app/pages/what-barrio-am-i-in.vue?macro=true";
import { default as what_45county_45am_45i_45in57gXEWBnyit94f_45Ri2bUzJrrsHyd5vZbyzxhMfVgEckMeta } from "/opt/buildhome/repo/app/pages/what-county-am-i-in.vue?macro=true";
import { default as what_45village_45am_45i_45inWTYdQsZouq3i88HCtQ_JRwhBYfVKCO27MoNSemN5snYMeta } from "/opt/buildhome/repo/app/pages/what-village-am-i-in.vue?macro=true";
import { default as school_45district7L1E4SX__Xqu4_45yEJPkORFVYVHt1UMuyDGgrDbxvPI0Meta } from "/opt/buildhome/repo/app/pages/atlas/school-district.vue?macro=true";
import { default as what_45district_45am_45i_45in3uvfaqvWvpRFMADJppSK88XlyeNz5Y8afzidy1_YQNQMeta } from "/opt/buildhome/repo/app/pages/what-district-am-i-in.vue?macro=true";
import { default as what_45township_45am_45i_45in9aQLqTSbbeOz2FxEeXOej0rEN8YpTvNjvpF22Cz4TYcMeta } from "/opt/buildhome/repo/app/pages/what-township-am-i-in.vue?macro=true";
import { default as what_45is_45my_45postal_45codeGrQaYvjcwSTmbQm22xXsyHt99XFHwv_45_45FMPsrt_45o9WoMeta } from "/opt/buildhome/repo/app/pages/what-is-my-postal-code.vue?macro=true";
import { default as what_45is_45my_45intersectionbguVI3dRDU3tIu7oVfhLbkId22DGZeMEF_457Z5Vc9n5MMeta } from "/opt/buildhome/repo/app/pages/what-is-my-intersection.vue?macro=true";
import { default as indexutw644bLEXxne_450Iz6E3R7VEc1017J9sh1fQakMJ3mQMeta } from "/opt/buildhome/repo/app/pages/county-map/[state]/index.vue?macro=true";
import { default as what_45municipality_45am_45i_45inlOa2Mev_CyRdNODq7JkH55MzC5Zum0hDcmCBNzUNj8wMeta } from "/opt/buildhome/repo/app/pages/what-municipality-am-i-in.vue?macro=true";
import { default as what_45neighborhood_45am_45i_45inL8qVk_45w7a2rjcQvJcPIzGRKtKwCDLX2fBHGJJ3S3uqYMeta } from "/opt/buildhome/repo/app/pages/what-neighborhood-am-i-in.vue?macro=true";
import { default as what_45are_45my_45gps_45coordinatesWzP7jj1QbJhYfonFqEmkeuS_yfD__45JQwaaEkyg1OJO4Meta } from "/opt/buildhome/repo/app/pages/what-are-my-gps-coordinates.vue?macro=true";
import { default as index_46servervGoSLx_45SROFOfoUeQ_45nXhNJ5OkBm7QJ4R8LjOZJvvuoMeta } from "/opt/buildhome/repo/app/pages/atlas/[country]/index.server.vue?macro=true";
import { default as what_45school_45district_45am_45i_45inzr6oMpVEhT9_oDm44XeIOGyWW5nlTL7fHwAQVC_45QT_kMeta } from "/opt/buildhome/repo/app/pages/what-school-district-am-i-in.vue?macro=true";
import { default as indexx_7uhEOToqSLvFYXKMqkoWPOTartmfS9z5Utqjod0_45wMeta } from "/opt/buildhome/repo/app/pages/county-map/[state]/[county]/index.vue?macro=true";
import { default as what_45indigenous_45territories_45am_45i_45inHTH0t7I5kMFd4wDOoYBhNFOrLQChUCiMFy6_45XUpNBLQMeta } from "/opt/buildhome/repo/app/pages/what-indigenous-territories-am-i-in.vue?macro=true";
import { default as indexhVhav58dbeJrA0e_bUS8d0pL6aSyuvV27p3fcNLAwDQMeta } from "/opt/buildhome/repo/app/pages/location/[latitude],[longitude]/[[name]]/[[wiki]]/index.vue?macro=true";
import { default as component_45stubShsHcOCXs7U4oHAmSkGUIOdDeuGpHK8BW_45SEAcFnL_45EMeta } from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.17.2_typescript@5.8.3_vite@6.3.5/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubShsHcOCXs7U4oHAmSkGUIOdDeuGpHK8BW_45SEAcFnL_45E } from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.17.2_typescript@5.8.3_vite@6.3.5/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "map",
    path: "/map",
    component: () => import("/opt/buildhome/repo/app/pages/map.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/opt/buildhome/repo/app/pages/index.vue")
  },
  {
    name: "peaks",
    path: "/peaks",
    component: () => import("/opt/buildhome/repo/app/pages/peaks.vue")
  },
  {
    name: "atlas-zone",
    path: "/atlas/zone",
    component: () => import("/opt/buildhome/repo/app/pages/atlas/zone.vue")
  },
  {
    name: "atlas-peaks",
    path: "/atlas/peaks",
    component: () => import("/opt/buildhome/repo/app/pages/atlas/peaks.vue")
  },
  {
    name: "rain-totals",
    path: "/rain-totals",
    component: () => import("/opt/buildhome/repo/app/pages/rain-totals.vue")
  },
  {
    name: "snow-totals",
    path: "/snow-totals",
    component: () => import("/opt/buildhome/repo/app/pages/snow-totals.vue")
  },
  {
    name: "atlas-county",
    path: "/atlas/county",
    component: () => import("/opt/buildhome/repo/app/pages/atlas/county.vue")
  },
  {
    name: "atlas-address",
    path: "/atlas/address",
    component: () => import("/opt/buildhome/repo/app/pages/atlas/address.vue")
  },
  {
    name: "atlas-cicadas",
    path: "/atlas/cicadas",
    component: () => import("/opt/buildhome/repo/app/pages/atlas/cicadas.vue")
  },
  {
    name: "atlas-zipcode",
    path: "/atlas/zipcode",
    component: () => import("/opt/buildhome/repo/app/pages/atlas/zipcode.vue")
  },
  {
    name: "about-slug",
    path: "/about/:slug?",
    component: () => import("/opt/buildhome/repo/app/pages/about/[[slug]].vue")
  },
  {
    name: "atlas-township",
    path: "/atlas/township",
    component: () => import("/opt/buildhome/repo/app/pages/atlas/township.vue")
  },
  {
    name: "cicadas-near-me",
    path: "/cicadas-near-me",
    component: () => import("/opt/buildhome/repo/app/pages/cicadas-near-me.vue")
  },
  {
    name: "what-is-my-city",
    path: "/what-is-my-city",
    component: () => import("/opt/buildhome/repo/app/pages/what-is-my-city.vue")
  },
  {
    name: "county-map",
    path: "/county-map",
    component: () => import("/opt/buildhome/repo/app/pages/county-map/index.vue")
  },
  {
    name: "what-is-my-state",
    path: "/what-is-my-state",
    component: () => import("/opt/buildhome/repo/app/pages/what-is-my-state.vue")
  },
  {
    name: "atlas-rain-totals",
    path: "/atlas/rain-totals",
    component: () => import("/opt/buildhome/repo/app/pages/atlas/rain-totals.vue")
  },
  {
    name: "atlas-snow-totals",
    path: "/atlas/snow-totals",
    component: () => import("/opt/buildhome/repo/app/pages/atlas/snow-totals.vue")
  },
  {
    name: "what-is-my-parish",
    path: "/what-is-my-parish",
    component: () => import("/opt/buildhome/repo/app/pages/what-is-my-parish.vue")
  },
  {
    name: "what-town-am-i-in",
    path: "/what-town-am-i-in",
    component: () => import("/opt/buildhome/repo/app/pages/what-town-am-i-in.vue")
  },
  {
    name: "what-zone-am-i-in",
    path: "/what-zone-am-i-in",
    component: () => import("/opt/buildhome/repo/app/pages/what-zone-am-i-in.vue")
  },
  {
    name: "atlas",
    path: "/atlas",
    component: () => createIslandPage("atlas")
  },
  {
    name: "atlas-neighborhood",
    path: "/atlas/neighborhood",
    component: () => import("/opt/buildhome/repo/app/pages/atlas/neighborhood.vue")
  },
  {
    name: "what-is-my-address",
    path: "/what-is-my-address",
    component: () => import("/opt/buildhome/repo/app/pages/what-is-my-address.vue")
  },
  {
    name: "what-is-my-country",
    path: "/what-is-my-country",
    component: () => import("/opt/buildhome/repo/app/pages/what-is-my-country.vue")
  },
  {
    name: "what-is-my-zipcode",
    path: "/what-is-my-zipcode",
    component: () => import("/opt/buildhome/repo/app/pages/what-is-my-zipcode.vue")
  },
  {
    name: "yesterdays-weather",
    path: "/yesterdays-weather",
    component: () => import("/opt/buildhome/repo/app/pages/yesterdays-weather.vue")
  },
  {
    name: "how-fast-am-i-going",
    path: "/how-fast-am-i-going",
    component: () => import("/opt/buildhome/repo/app/pages/how-fast-am-i-going.vue")
  },
  {
    name: "what-barrio-am-i-in",
    path: "/what-barrio-am-i-in",
    component: () => import("/opt/buildhome/repo/app/pages/what-barrio-am-i-in.vue")
  },
  {
    name: "what-county-am-i-in",
    path: "/what-county-am-i-in",
    component: () => import("/opt/buildhome/repo/app/pages/what-county-am-i-in.vue")
  },
  {
    name: "what-village-am-i-in",
    path: "/what-village-am-i-in",
    component: () => import("/opt/buildhome/repo/app/pages/what-village-am-i-in.vue")
  },
  {
    name: "atlas-school-district",
    path: "/atlas/school-district",
    component: () => import("/opt/buildhome/repo/app/pages/atlas/school-district.vue")
  },
  {
    name: "what-district-am-i-in",
    path: "/what-district-am-i-in",
    component: () => import("/opt/buildhome/repo/app/pages/what-district-am-i-in.vue")
  },
  {
    name: "what-township-am-i-in",
    path: "/what-township-am-i-in",
    component: () => import("/opt/buildhome/repo/app/pages/what-township-am-i-in.vue")
  },
  {
    name: "what-is-my-postal-code",
    path: "/what-is-my-postal-code",
    component: () => import("/opt/buildhome/repo/app/pages/what-is-my-postal-code.vue")
  },
  {
    name: "what-is-my-intersection",
    path: "/what-is-my-intersection",
    component: () => import("/opt/buildhome/repo/app/pages/what-is-my-intersection.vue")
  },
  {
    name: "county-map-state",
    path: "/county-map/:state()",
    component: () => import("/opt/buildhome/repo/app/pages/county-map/[state]/index.vue")
  },
  {
    name: "what-municipality-am-i-in",
    path: "/what-municipality-am-i-in",
    component: () => import("/opt/buildhome/repo/app/pages/what-municipality-am-i-in.vue")
  },
  {
    name: "what-neighborhood-am-i-in",
    path: "/what-neighborhood-am-i-in",
    component: () => import("/opt/buildhome/repo/app/pages/what-neighborhood-am-i-in.vue")
  },
  {
    name: "what-are-my-gps-coordinates",
    path: "/what-are-my-gps-coordinates",
    component: () => import("/opt/buildhome/repo/app/pages/what-are-my-gps-coordinates.vue")
  },
  {
    name: "atlas-country",
    path: "/atlas/:country()",
    component: () => createIslandPage("atlas-country")
  },
  {
    name: "what-school-district-am-i-in",
    path: "/what-school-district-am-i-in",
    component: () => import("/opt/buildhome/repo/app/pages/what-school-district-am-i-in.vue")
  },
  {
    name: "county-map-state-county",
    path: "/county-map/:state()/:county()",
    component: () => import("/opt/buildhome/repo/app/pages/county-map/[state]/[county]/index.vue")
  },
  {
    name: "what-indigenous-territories-am-i-in",
    path: "/what-indigenous-territories-am-i-in",
    component: () => import("/opt/buildhome/repo/app/pages/what-indigenous-territories-am-i-in.vue")
  },
  {
    name: "location-latitude,longitude-name-wiki",
    path: "/location/:latitude(),:longitude()/:name?/:wiki?",
    component: () => import("/opt/buildhome/repo/app/pages/location/[latitude],[longitude]/[[name]]/[[wiki]]/index.vue")
  },
  {
    name: component_45stubShsHcOCXs7U4oHAmSkGUIOdDeuGpHK8BW_45SEAcFnL_45EMeta?.name,
    path: "/ads.txt",
    component: component_45stubShsHcOCXs7U4oHAmSkGUIOdDeuGpHK8BW_45SEAcFnL_45E
  },
  {
    name: component_45stubShsHcOCXs7U4oHAmSkGUIOdDeuGpHK8BW_45SEAcFnL_45EMeta?.name,
    path: "/speed-calculator",
    component: component_45stubShsHcOCXs7U4oHAmSkGUIOdDeuGpHK8BW_45SEAcFnL_45E
  },
  {
    name: component_45stubShsHcOCXs7U4oHAmSkGUIOdDeuGpHK8BW_45SEAcFnL_45EMeta?.name,
    path: "/speed-converter",
    component: component_45stubShsHcOCXs7U4oHAmSkGUIOdDeuGpHK8BW_45SEAcFnL_45E
  },
  {
    name: component_45stubShsHcOCXs7U4oHAmSkGUIOdDeuGpHK8BW_45SEAcFnL_45EMeta?.name,
    path: "/snow-totals/atlas",
    component: component_45stubShsHcOCXs7U4oHAmSkGUIOdDeuGpHK8BW_45SEAcFnL_45E
  },
  {
    name: component_45stubShsHcOCXs7U4oHAmSkGUIOdDeuGpHK8BW_45SEAcFnL_45EMeta?.name,
    path: "/how-far-is-it",
    component: component_45stubShsHcOCXs7U4oHAmSkGUIOdDeuGpHK8BW_45SEAcFnL_45E
  },
  {
    name: component_45stubShsHcOCXs7U4oHAmSkGUIOdDeuGpHK8BW_45SEAcFnL_45EMeta?.name,
    path: "/privacy",
    component: component_45stubShsHcOCXs7U4oHAmSkGUIOdDeuGpHK8BW_45SEAcFnL_45E
  },
  {
    name: component_45stubShsHcOCXs7U4oHAmSkGUIOdDeuGpHK8BW_45SEAcFnL_45EMeta?.name,
    path: "/what-is-my-neighborhood",
    component: component_45stubShsHcOCXs7U4oHAmSkGUIOdDeuGpHK8BW_45SEAcFnL_45E
  },
  {
    name: component_45stubShsHcOCXs7U4oHAmSkGUIOdDeuGpHK8BW_45SEAcFnL_45EMeta?.name,
    path: "/what-is-my-gps-coordinates",
    component: component_45stubShsHcOCXs7U4oHAmSkGUIOdDeuGpHK8BW_45SEAcFnL_45E
  },
  {
    name: component_45stubShsHcOCXs7U4oHAmSkGUIOdDeuGpHK8BW_45SEAcFnL_45EMeta?.name,
    path: "/what-is-my-county",
    component: component_45stubShsHcOCXs7U4oHAmSkGUIOdDeuGpHK8BW_45SEAcFnL_45E
  },
  {
    name: component_45stubShsHcOCXs7U4oHAmSkGUIOdDeuGpHK8BW_45SEAcFnL_45EMeta?.name,
    path: "/convert-elevation",
    component: component_45stubShsHcOCXs7U4oHAmSkGUIOdDeuGpHK8BW_45SEAcFnL_45E
  }
]